import {BaseContainerModel} from "../../base-container.model";
import { bl_wf_md_process_ext_RowClass, bl_wf_md_process_hdr_RowClass, bl_wf_md_process_hdr_RowInterface, bl_wf_md_process_line_RowClass} from "../../../dbschema";

export class WfMdProcessHdrContainerModel extends BaseContainerModel{
  bl_wf_md_process_hdr: bl_wf_md_process_hdr_RowInterface = new bl_wf_md_process_hdr_RowClass();
  bl_wf_md_process_exts: bl_wf_md_process_ext_RowClass[] = [];
  bl_wf_md_process_lines: bl_wf_md_process_line_RowClass[] = [];
}
